import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { AppModule } from '../../app.module';
import { GoogleMap, MapMarker } from '@angular/google-maps';
import { NotificationService } from '../../shared/notification.service';
import { IncidentLocation } from '../../models/incident';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-map-select',
  imports: [AppModule, GoogleMap, MapMarker],
  templateUrl: './map-select.html',
  styleUrl: './map-select.less'
})
export class MapSelect implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('searchBox') searchBox!: ElementRef;
  @Input('mapMarkerLocation') mapMarkerLocation?: IncidentLocation;
  @Input('zoom') zoom: number = 8;
  @Input('isReadonly') isReadonly: boolean = false;
  @Output() locationSelected = new EventEmitter<IncidentLocation >();
  
  
  // Initial map center and zoom level
  center: google.maps.LatLngLiteral = { lat: -29.1, lng: 24.2 }; 
  //zoom = 15;
  
  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true, // Hides default controls like zoom and street view
    clickableIcons: false, // Prevents clicking on points of interest
  };
    
    
  
  selectedPosition?: google.maps.LatLngLiteral;  // The position where the user clicked, initially undefined - #TODO: add component level input to select location
  selectedLocationDetails?: google.maps.places.PlaceResult | any;  
  private geocoder = new google.maps.Geocoder();

  constructor(private zone: NgZone, private notification: NotificationService, private authService: AuthService) {
    if (authService.user?.lat && authService.user?.lon) {
      this.center = { lat: authService.user.lat, lng: authService.user.lon };
      //this.zoom = 10;
    }
    console.log(authService.user?.lat, authService.user?.lon);

  }

  ngOnInit(): void {
    if (this.mapMarkerLocation && this.mapMarkerLocation.latitude && this.mapMarkerLocation.longitude) {
      console.log('Initial map marker location:', this.mapMarkerLocation);
      
      // Set the map center to the provided coordinates
      this.center = { lat: this.mapMarkerLocation.latitude, lng: this.mapMarkerLocation.longitude };
      // Set the marker position
      this.selectedPosition = { lat: this.mapMarkerLocation.latitude, lng: this.mapMarkerLocation.longitude };
      // Zoom in closer since we have a specific point
      this.zoom = 15;
      
      // Optionally, you can also fetch the address details for this initial point
      const latLng = new google.maps.LatLng(this.mapMarkerLocation.latitude, this.mapMarkerLocation.longitude);
      this.geocodeLocation(latLng);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mapMarkerLocation'] && this.mapMarkerLocation && this.mapMarkerLocation.latitude && this.mapMarkerLocation.longitude) {
      console.log('Updated map marker location:', this.mapMarkerLocation);

      this.center = { lat: this.mapMarkerLocation.latitude, lng: this.mapMarkerLocation.longitude };
      this.selectedPosition = { lat: this.mapMarkerLocation.latitude, lng: this.mapMarkerLocation.longitude };
      if (!changes['mapMarkerLocation'].firstChange) {
        this.zoom = 15;
      }
    }
  }

  ngAfterViewInit(): void {
    // Only initialize autocomplete if not in readonly mode
    if (this.isReadonly || !this.searchBox) {
      return;
    }
    
    // Initialize the Autocomplete service
    const autocomplete = new google.maps.places.Autocomplete(this.searchBox.nativeElement, {
      componentRestrictions: { country: 'za' }
    });

    // Listen for the 'place_changed' event
    autocomplete.addListener('place_changed', () => {
      this.zone.run(() => {
        const place = autocomplete.getPlace();

        if (place.geometry && place.geometry.location) {
          // Update map and marker with the selected place
          this.updateMapLocation(place);
        } else {
          this.notification.showWarningTimer("No details available for input: '" + place.name + "'", 3);
        }
      });
    });
  }

  /**
   * Handles the map click event.
   * @param event The map mouse event containing the coordinates of the click.
   */
  handleMapClick(event: google.maps.MapMouseEvent): void {
    // Prevent location changes in readonly mode
    if (this.isReadonly) {
      return;
    }
    
    if (event.latLng) {
      // Set the marker position to the clicked coordinates
      this.selectedPosition = event.latLng.toJSON();
      
      // Use the Geocoder to get location details from the coordinates - including address description
      this.geocodeLocation(event.latLng);
    }
  }

  /**
   * Calls the Geocoding API to reverse geocode the given location.
   * @param latLng The latitude and longitude to geocode.
   */
  private geocodeLocation(latLng: google.maps.LatLng): void {
    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === 'OK' && results && results[0]) {
        // Successfully found location details
        this.selectedLocationDetails = results[0];
        console.log('Geocoding Result:', this.selectedLocationDetails);
        this.onSelectLocation();
      } else {
        // Not found
        this.selectedLocationDetails = undefined;
        this.notification.showWarningTimer('Geocode was not successful for the following reason: ' + status, 3);
      }
    });
  }

  private updateMapLocation(place: google.maps.places.PlaceResult | google.maps.GeocoderResult): void {
    if (place.geometry && place.geometry.location) {
      // Set the map's center to the new location
      this.center = place.geometry.location.toJSON();

      // Place a marker at the new location
      this.selectedPosition = this.center;
      
      // Update the details panel
      this.selectedLocationDetails = place;

      // Zoom in on the selected location
      this.zoom = 15;
      
      console.log('Updated Location:', this.selectedLocationDetails);
      this.onSelectLocation();
      
    }
  }

  public onSelectLocation(): void {
    if (this.selectedPosition) {      
      var descriptionShort = '';
      for (var addItem of this.selectedLocationDetails?.address_components) {
        if (addItem.types.includes('sublocality_level_1')) {
          descriptionShort += addItem.long_name + ', ';
        }
        if (addItem.types.includes('locality')) {
          descriptionShort += addItem.long_name + ', ';
        }
        if (addItem.types.includes('administrative_area_level_1')) {
          descriptionShort += addItem.short_name;
        }
      }      
      this.locationSelected.emit({
        incidentId: 0,
        latitude: this.selectedPosition.lat,
        longitude: this.selectedPosition.lng,
        description: this.selectedLocationDetails?.formatted_address,
        descriptionShort: descriptionShort
      });
    }
  }

  public onClearSelection(): void {
    this.locationSelected.emit();
  }

}
